import { getOrderByCode, getOrdersMe } from "apis/orderApi";
import { doCall } from "common/genericSaga";
import { all, call, put, takeEvery } from "redux-saga/effects";
import {
  ORDERS_ME_REQUESTED,
  ORDERS_ME_REQUEST_FAILED,
  ORDER_BY_CODE_REQUESTED,
  ORDER_BY_CODE_REQUEST_FAILED,
  receiveOrder,
  receiveOrdersMe
} from "./orderActions";

export function* doRequestOrdersMe(action, requestInfo) {
  const offset = (action.pageNumber - 1) * action.pageSize;
  const ordersMeResponse = yield call(getOrdersMe, requestInfo, action.orderState, offset, action.pageSize);
  yield put(
    receiveOrdersMe(
      action.orderState,
      action.pageSize,
      action.pageNumber,
      ordersMeResponse.total,
      ordersMeResponse.items
    )
  );
}

export function* doRequestOrderByCode(action, requestInfo) {
  const order = yield call(getOrderByCode, requestInfo, action.id);
  yield put(receiveOrder(order));
}

export function* watchOrdersMe() {
  yield all([
    takeEvery(ORDERS_ME_REQUESTED, doCall(doRequestOrdersMe, ORDERS_ME_REQUEST_FAILED)),
    takeEvery(ORDER_BY_CODE_REQUESTED, doCall(doRequestOrderByCode, ORDER_BY_CODE_REQUEST_FAILED))
  ]);
}
